import {
    mdiAccountMultipleOutline,
    mdiFormatListBulletedSquare,
    mdiPlusBoxOutline,
    mdiAccountPlusOutline,
    mdiAccountGroup,
    mdiRss
} from '@mdi/js'
import __ from './trans';

export default [
    {
        isTitle: true,
        label: __('Prices'),
        permissions: ['edit price config']
    },
    [
        {
            route: 'price-configs.index',
            icon: mdiFormatListBulletedSquare,
            label: __('List of prices'),
            permissions: ['edit price config']
        },
        {
            route: 'price-configs.create',
            icon: mdiPlusBoxOutline,
            label: __('Create :resource', {resource: __('The Price').toLowerCase()}),
            permissions: ['edit price config']
        }
    ],
    {
        isTitle: true,
        label: __('Feeds'),
        permissions: ['edit feed config']
    },
    [
        {
            route: 'feed-configs.index',
            icon: mdiRss,
            label: __('List of feeds'),
            permissions: ['edit feed config']
        },
        {
            route: 'feed-configs.create',
            icon: mdiPlusBoxOutline,
            label: __('Create :resource', {resource: __('Feed').toLowerCase()}),
            permissions: ['edit feed config']
        }
    ],
    {
        isTitle: true,
        label: __('Users'),
        permissions: ['edit users', 'edit roles']
    },
    [
        {
            route: 'users.index',
            icon: mdiAccountGroup ,
            label: __('List of users'),
            permissions: ['edit users']
        },
        {
            route: 'users.create',
            icon: mdiAccountPlusOutline,
            label: __('Create user'),
            permissions: ['edit users']
        },
        {
            route: 'roles.index',
            icon: mdiAccountMultipleOutline,
            label: __('Roles'),
            permissions: ['edit roles']
        }
    ]
]
